import { useEffect, useState } from 'react';

/**
 * Returns `value` debounced by `ms` milliseconds. When `value` changes,
 * the returned snapshot only updates after the timer elapses without
 * another change. Resets the timer on every change.
 *
 * Introduced for Story 4.1.7 slice 5 — the NextPax booking card pipes
 * stepper input through this hook before calling
 * `GET /accommodations/{id}/rate-breakdown` to avoid one round-trip per
 * click. No third-party dependency: the codebase has no existing debounce
 * util in `src/hooks/`, and pulling in `lodash.debounce` for one call
 * site is not justified.
 */
export function useDebouncedValue<T>(value: T, ms: number): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const handle = setTimeout(() => {
      setDebounced(value);
    }, ms);
    return () => clearTimeout(handle);
  }, [value, ms]);

  return debounced;
}
